// Mappers for membership-related entities
// Identity mappers for 1:1 mapping

import type {
  SearchUsersResponseDto,
  DeleteUserResponseDto,
  GetConnectorHealthResponseDto,
  DeviceAliveEventResponseDto,
  RemoveTenantResponseDto,
  ChangeAccessResponseDto,
  ValidateOnboardingResponseDto,
  ConnectorProductionConfigurationDetailsResponseDto,
  ConnectorIpRangeDto,
  ConnectorIpScanStatusDto,
  TimezoneDto,
  CountryDto,
  ApiKeyDto,
  ImnooApiKeyDto,
  UpdateImnooApiKeyResponseDto,
  GenerateApiKeyResponseDto,
  ErpSourceSystemTypeDto,
  CheckApiResponseDto,
} from '../../generated/models';

import type {
  SearchUsersResponse,
  DeleteUserResponse,
  GetConnectorHealthResponse,
  DeviceAliveEventResponse,
  RemoveTenantResponse,
  ChangeAccessResponse,
  ValidateOnboardingResponse,
  ConnectorProductionConfigurationDetailsResponse,
  ConnectorIpRange,
  ConnectorIpScanStatus,
  Timezone,
  Country,
  ApiKey,
  ImnooApiKey,
  UpdateImnooApiKeyResponse,
  GenerateApiKeyResponse,
  ErpSourceSystemType,
  CheckApiResponse,
} from '../types';

// Response mappers (identity for 1:1)
export const toCheckApiResponse = (dto: CheckApiResponseDto): CheckApiResponse => dto;
export const toSearchUsersResponse = (dto: SearchUsersResponseDto): SearchUsersResponse => dto;
export const toDeleteUserResponse = (dto: DeleteUserResponseDto): DeleteUserResponse => dto;
export const toGetConnectorHealthResponse = (dto: GetConnectorHealthResponseDto): GetConnectorHealthResponse => dto;
export const toDeviceAliveEventResponse = (dto: DeviceAliveEventResponseDto): DeviceAliveEventResponse => dto;
export const toRemoveTenantResponse = (dto: RemoveTenantResponseDto): RemoveTenantResponse => dto;
export const toChangeAccessResponse = (dto: ChangeAccessResponseDto): ChangeAccessResponse => dto;
export const toValidateOnboardingResponse = (dto: ValidateOnboardingResponseDto): ValidateOnboardingResponse => dto;
export const toConnectorProductionConfigurationDetailsResponse = (
  dto: ConnectorProductionConfigurationDetailsResponseDto
): ConnectorProductionConfigurationDetailsResponse => dto;
export const toUpdateImnooApiKeyResponse = (dto: UpdateImnooApiKeyResponseDto): UpdateImnooApiKeyResponse => dto;
export const toGenerateApiKeyResponse = (dto: GenerateApiKeyResponseDto): GenerateApiKeyResponse => dto;

// Entity mappers (single)
export const toConnectorIpRange = (dto: ConnectorIpRangeDto): ConnectorIpRange => dto;
export const toConnectorIpScanStatus = (dto: ConnectorIpScanStatusDto): ConnectorIpScanStatus => dto;
export const toTimezone = (dto: TimezoneDto): Timezone => dto;
export const toCountry = (dto: CountryDto): Country => dto;
export const toApiKey = (dto: ApiKeyDto): ApiKey => dto;
export const toImnooApiKey = (dto: ImnooApiKeyDto): ImnooApiKey => dto;
export const toErpSourceSystemType = (dto: ErpSourceSystemTypeDto): ErpSourceSystemType => dto;

// Array mappers
export const toConnectorIpRanges = (dtos: ConnectorIpRangeDto[]): ConnectorIpRange[] => dtos.map(toConnectorIpRange);
export const toConnectorIpScanStatuses = (dtos: ConnectorIpScanStatusDto[]): ConnectorIpScanStatus[] =>
  dtos.map(toConnectorIpScanStatus);
export const toTimezones = (dtos: TimezoneDto[]): Timezone[] => dtos.map(toTimezone);
export const toCountries = (dtos: CountryDto[]): Country[] => dtos.map(toCountry);
export const toApiKeys = (dtos: ApiKeyDto[]): ApiKey[] => dtos.map(toApiKey);
export const toImnooApiKeys = (dtos: ImnooApiKeyDto[]): ImnooApiKey[] => dtos.map(toImnooApiKey);
export const toErpSourceSystemTypes = (dtos: ErpSourceSystemTypeDto[]): ErpSourceSystemType[] =>
  dtos.map(toErpSourceSystemType);
